<ng-container>
  <!--slim + expand-->
  <!-- <a *ngIf="(!item.routerLink || item.items) && item.visible !== false" [attr.href]="item.url"
     (click)="itemClick($event)" (mouseenter)="onMouseEnter()"
     [ngClass]="item.class" [attr.target]="item.target" tabindex="0" pRipple [pTooltip]="item.label"
     [tooltipDisabled]="!(isSlim && root && (!active))
     "routerLinkActive="active-route">
    <i [ngClass]="item.icon" class="layout-menuitem-icon"></i>
    <span class="layout-menuitem-text">{{ item.label }}</span>
    <i class="pi pi-fw pi-angle-down layout-submenu-toggler" *ngIf="item.items"></i>
  </a> -->

  <a
    (click)="itemClick($event)"
    [ngClass]="item.class"
    [routerLink]="item.routerLink"
    routerLinkActive="active-route"
    [routerLinkActiveOptions]="
      item.routerLinkActiveOptions || {
        paths: 'subset',
        queryParams: 'ignored',
        matrixParams: 'ignored',
        fragment: 'ignored'
      }
    "
    [fragment]="item.fragment"
    [queryParamsHandling]="item.queryParamsHandling"
    [preserveFragment]="item.preserveFragment"
    [replaceUrl]="item.replaceUrl"
    [queryParams]="item.queryParams"
    tabindex="0"
    pRipple
    [pTooltip]="'MENU.' + item.title | translate"
    [tooltipDisabled]="true"
  >
    <i *ngIf="item.icon" [ngClass]="item.icon" class="layout-menuitem-icon"></i>
    <span class="layout-menuitem-text">{{ 'MENU.' + item.title | translate }}</span>
    <img
      class="layout-submenu-toggler"
      width="10"
      height="10"
      src="/assets/layout/images/dropdown-rignt.svg"
      alt="Data not found"
      [ngClass]="{ keyActive: key === menuActiveKey }"
      *ngIf="item.items"
    />
  </a>

  <ul
    #submenu
    *ngIf="item.items && item.visible !== false"
    [@children]="submenuAnimationState$ | async"
    (@children.done)="onSubmenuAnimated($event)"
  >
    <ng-template ngFor let-child let-i="index" [ngForOf]="item.items">
      <hr *ngIf="child.separator" class="section-divider" />
      <li
        app-menuitem
        [item]="child"
        [index]="i"
        [parentKey]="key"
        [class]="child.badgeClass"
        [(menuActiveKey)]="menuActiveKey"
      ></li>
    </ng-template>
  </ul>
  <ul *ngIf="!item.items"></ul>
</ng-container>
